"use client";

import { SideMenu } from "@/components/common/side-menu";

import { useLayout, UseLayoutProps } from "./use-layout";

export type LayoutProps = UseLayoutProps;

function Layout(props: LayoutProps) {
  const { children, showSidebar, docsMenu, styles, Comp } = useLayout(props);
  return (
    <Comp {...(showSidebar ? { className: styles.base() } : {})}>
      {showSidebar && docsMenu && <SideMenu data={docsMenu} />}
      <main className={styles.main()}>{children}</main>
    </Comp>
  );
}

export default Layout;
